import React from 'react'
import { Redirect } from 'react-router-dom'

import { authorization } from 'Module/Auth/Auth'
import { NotAuthorised } from 'Components/Page'

export function PrivateRoute({ children, isNeedToHide = false, ...rest }) {
  if (isNeedToHide) {
    return <NotAuthorised {...rest} />
  }
  if (!rest.isRestricted && authorization.isLogged()) {
    return children
  }

  return <Redirect to={'/login'} />
}

export function AdminRoute({ children, ...rest }) {
  if (authorization.isAdmin()) {
    return children
  }

  return <NotAuthorised {...rest} />
}

export function CityManagerRoute({ children, isNeedToHide = false, ...rest }) {
  if (
    (authorization.isAdmin() || authorization.isCityManager()) &&
    !isNeedToHide
  ) {
    return children
  }

  return <NotAuthorised {...rest} />
}

export const StrictCityManagerRoute = ({ children, ...rest }) => {
  if (
    authorization.isAdmin() &&
    authorization.isCityManager() &&
    !authorization.isCityManagerAssistant()
  ) {
    return children
  }

  return <NotAuthorised {...rest} />
}

export function ClientAdminRoute({ children, ...rest }) {
  if (authorization.isAdmin() || authorization.isClientAdmin()) {
    return children
  }

  return <NotAuthorised {...rest} />
}

export function NotSpyRoute({ children, ...rest }) {
  if (authorization.isSpy()) {
    return <NotAuthorised {...rest} />
  }

  return children
}

export function ClientAndClientAdminRoute({ children, ...rest }) {
  if (
    authorization.isClient() ||
    authorization.isClientAdmin() ||
    authorization.isAdmin()
  ) {
    return children
  }
  return <NotAuthorised {...rest} />
}
